import { useLocation, useNavigate } from 'react-router-dom';
import useStore from '../Hooks/useStore';
import * as H from '../Header/Style';
import addprodutoGrey from '../../images/addprodutoGrey.png';
import addProdutowhite from '../../images/addProdutowhite.png';
import folder from '../../images/folder.png';
import folderWhite from '../../images/folderWhite.png';
import promocao from '../../images/promocao.png';
import promocaoWhite from '../../images/promocaoWhite.png';
import { BoxGeralTooprice } from '../Page/Tools/Price/styled';
import FormPriceSearch from '../Form/FormPriceSearch';
import SVG from '../SVG';
import * as S from './styled';
import useCompaniesController from '../Page/Exports/Companies/useCompaniesController';
import useInvoicesController from '../Page/Exports/Invoices/useInvoicesController';
import useTaxesController from '../Page/Exports/Taxes/useTaxesController';
import useDepositsController from '../Page/Exports/Deposits/useDepositsController';
import useValiditiesController from '../Page/Validity/Validities/useValiditiesController';
import useStatusController from '../Page/Validity/Status/useStatusController';
import useLogisticsController from '../Page/Exports/Logistic/useLogisticsController';

const Controls = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [getters] = useStore();
  const {
    banner: { getBanner },
  } = getters;

  const { InvoiceControls } = useInvoicesController();
  const { TaxControls } = useTaxesController();
  const { LogisticControls } = useLogisticsController();
  const { CompanyControls } = useCompaniesController();
  const { DepositControls } = useDepositsController();
  const { ValidityControls } = useValiditiesController();
  const { StatusControls } = useStatusController();

  const currentRoute = location.pathname;

  const bannerRoute = '/tools/banner';
  const bannerFilesRoute = '/tools/banner/files';
  const bannerPromotionsRoute = '/tools/banner/promotions';
  const ticketOfflinePricesRoute = '/tools/ticket/offline-prices';
  const isBannerRoute = currentRoute === '/tools/banner';
  const isBannerFilesRoute = currentRoute === '/tools/banner/files';
  const isBannerPromotionsRoute = currentRoute === '/tools/banner/promotions';
  const isTicketOfflinePricesRoute =
    currentRoute === '/tools/ticket/offline-prices';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginRight: '1rem',
      }}
    >
      <InvoiceControls />
      <CompanyControls />
      <TaxControls />
      <LogisticControls />
      <DepositControls />
      <ValidityControls />
      <StatusControls />

      {currentRoute === '/tools/exports' && (
        <>
          <S.ControlContainer>
            <S.Control>
              <SVG.Icon.Filter width={24} height={24} />
            </S.Control>
          </S.ControlContainer>
        </>
      )}

      {currentRoute.includes('/tools/banner') && (
        <>
          <H.ButtonHeader
            className="button-header"
            active={isBannerRoute}
            onClick={() => navigate(bannerRoute)}
          >
            <H.CriarEditarCartaz
              src={isBannerRoute ? addProdutowhite : addprodutoGrey}
            />
            {getBanner('isEditMode') ? 'EDITAR' : 'CRIAR'} CARTAZ
          </H.ButtonHeader>
          <H.ButtonHeader
            className="button-header"
            active={isBannerFilesRoute}
            onClick={() => navigate(bannerFilesRoute)}
          >
            <H.CriarEditarCartaz
              src={isBannerFilesRoute ? folderWhite : folder}
            />
            MEUS CARTAZES
          </H.ButtonHeader>
          <H.ButtonHeader
            className="button-header"
            active={isBannerPromotionsRoute}
            onClick={() => navigate(bannerPromotionsRoute)}
          >
            <H.CriarEditarCartaz
              src={isBannerPromotionsRoute ? promocaoWhite : promocao}
            />
            PROMOÇÕES
          </H.ButtonHeader>
        </>
      )}

      {currentRoute.includes('tools/price') && (
        <div className="tools-price-container">
          <BoxGeralTooprice>
            <FormPriceSearch />
          </BoxGeralTooprice>
        </div>
      )}

      {currentRoute.includes('/tools/ticket') && (
        <H.ButtonHeader
          className="button-header"
          active={isTicketOfflinePricesRoute}
          onClick={() => navigate(ticketOfflinePricesRoute)}
        >
          PREÇOS OFFLINE
        </H.ButtonHeader>
      )}
    </div>
  );
};

export default Controls;
